module.exports = __webpack_public_path__ + "static/media/Aastha-Shah.f57074b3.png";